module.exports = __webpack_public_path__ + "static/Irriglobe_Installation_Résidentiel_FINAL_480p-235422bfc89e0e4cfd7682606b41d8ac.mp4";